import styled from "styled-components";

export const FooterStyle = styled.footer`
    background-color: var(--cll-primary-lighter);
    font-weight: var(--fw-text);
    font-size: 1.3rem;
    text-align: center;
    padding: .2rem;
    svg,
    a {
        color: var(--cll-primary-alt);
    }
`;